var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sidebar"},[_c('h1',{staticClass:"font-weight-normal pb-3"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"lines d-sm-none d-none d-lg-block"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }